import gql from "graphql-tag"
import { UserFragmentDoc } from "../../api/generated"

export default gql`
  query UserQuery($id: Int!) {
    user(id: $id) {
      ...User
    }
  }
  ${UserFragmentDoc}
`
